import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { NotificationDescriptor } from './model/notification';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class NotificationManagementService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'NotificationManagement',
      authService,
      config.NMSConfig
    );
  }

  public create(notificationEntity: NotificationDescriptor): Promise<string> {
    return super.post<string>(
      new NotificationDescriptor({
        id: undefined,
        href: undefined,
        title: notificationEntity.title,
        profileId: notificationEntity.profileId,
        percentComplete: notificationEntity.percentComplete,
        hasManifest: notificationEntity.hasManifest,
        reference: notificationEntity.reference,
        errorMessage: notificationEntity.errorMessage,
        modified: notificationEntity.modified,
        deleted: notificationEntity.deleted
      }));
  }

  public getNotifications(view?: View): Promise<List<NotificationDescriptor>> {
    return super.get<List<NotificationDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: NotificationDescriptor): Promise<NotificationDescriptor> {
    return super.put<NotificationDescriptor>(id, role);
  }

  public getById(id: string): Promise<NotificationDescriptor> {
    return super.get<NotificationDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/notification/notification.service.ts